import resolveConfig from "tailwindcss/resolveConfig";
//@ts-ignore
import tailwindConfig from "../../tailwind.config.js";

const fullConfig = resolveConfig(tailwindConfig);

type BreakpointKey = "sm" | "md" | "lg" | "xl" | "2xl";

export const getTailwindBreakpointValue = (
  breakpoint: BreakpointKey
): number => {
  return parseInt(fullConfig.theme.screens[breakpoint], 10);
};
